import { useEffect, useState } from 'react'
import { SettingsContent } from './SettingsContent'

interface SettingsModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function SettingsModal({ open, onOpenChange }: SettingsModalProps) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (open) {
      requestAnimationFrame(() => setVisible(true))
    } else {
      setVisible(false)
    }
  }, [open])

  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onOpenChange(false)
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onOpenChange])

  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div
        className={`absolute inset-0 bg-neutral-200/60 backdrop-blur-[1px] transition-opacity duration-150 ${visible ? 'opacity-100' : 'opacity-0'}`}
        onClick={() => onOpenChange(false)}
      />
      <div
        className={`relative z-10 w-full max-w-[760px] h-[min(560px,85vh)] bg-card border border-neutral-300 rounded-2xl shadow-[0_12px_30px_-12px_rgba(0,0,0,0.14)] overflow-hidden transition-all duration-150 ${
          visible ? 'opacity-100 scale-100' : 'opacity-0 scale-[0.97]'
        }`}
      >
        <SettingsContent onClose={() => onOpenChange(false)} />
      </div>
    </div>
  )
}
